import React from 'react';
import ContentWrapper from '@opendoor/bricks/deprecated/UNSAFE_layout/ContentWrapper';
import { colors, space } from '@opendoor/bricks/theme/eero';
import { Flex, FlexProps, CardProps } from '@opendoor/bricks/core';
import ContentCard from '@opendoor/bricks/deprecated/UNSAFE_layout/ContentCard';
import styled from '@emotion/styled';
import { media } from '@opendoor/bricks/theme/legacy/foundations/mediaBreakpoints';

/** TODO: Add documentation */
export const CakeContentWrapper: React.FC<CardProps> = ({ children, ...rest }) => (
  <ContentWrapper
    width="100%"
    maxWidth="570px"
    borderX={`1px solid ${colors.neutrals30}`}
    borderBottomLeftRadius="none"
    borderBottomRightRadius="none"
    mb={0}
    {...rest}
  >
    {children}
  </ContentWrapper>
);

/** TODO: Add documentation */
export const CakeContentInner: React.FC<FlexProps> = (props) => (
  <Flex alignItems="center" flexDirection="column" px={[5, 7]} {...props} />
);

/* eslint-disable */
export const CakeContentCard = styled(ContentCard)<{
  fullWidth?: boolean;
  isInlay?: boolean;
  isGray?: boolean;
}>`
  padding: ${(props) => (props.fullWidth ? 0 : space[8])}px;
  background: ${(props) =>
    props.isGray ? colors.neutrals10 : props.isInlay ? colors.blue30 : colors.neutrals0};

  ${media.smallerThan.LG} {
    padding: ${(props) => (props.fullWidth ? 0 : space[7])}px;
  }

  ${media.smallerThan.XXS} {
    padding: ${(props) => (props.fullWidth ? 0 : space[5])}px;
  }
`;
